import { PropTypes } from 'prop-types';
import React from 'react';

import { COLORS } from '../../constants/colors';
import { toCamelCase } from '../../utils';
import CardImageBasedLarge from '../Cards/CardImageBased/CardImageBasedLarge';
import CardImageBasedSmall from '../Cards/CardImageBased/CardImageBasedSmall';
import HomepageActiveEconomySidebar from './HomepageActiveEconomySidebar';
import HomepageMosaic from './HomepageMosaic';

const HomepageActiveEconomy = ({
  activeEconomy,
  header,
  mosaic,
  mosaicQuote,
}) => {
  const largeCard = header?.[0];
  return (
    <div className="sm:my-18 my-14" data-module-id="homepage_active_economy">
      <div
        className="homepage-grid-container gap-y-8"
        data-component-id="homepage_active_economy_link"
      >
        <div className="col-span-12 lg:col-span-16 sm:col-span-9">
          <CardImageBasedLarge
            backgroundColor={
              COLORS[toCamelCase(largeCard?.header?.backgroundColor)]
            }
            date={largeCard?.publishedDate}
            description={largeCard?.header?.headline}
            image={largeCard?.cardImage}
            slug={largeCard?.slug}
            tags={largeCard?.tags}
            textColor={COLORS[toCamelCase(largeCard?.header?.textColor)]}
            title={largeCard?.title}
          />
        </div>
        <div className="grid grid-cols-2 col-span-12 sm:grid-cols-1 homepage-grid-gaps gap-y-8 lg:col-span-4 sm:col-span-3">
          {header?.slice(1).map((item) => {
            if (!item) return null;
            const { cardImage, id, publishedDate, slug, tags, title } = item;

            return (
              <CardImageBasedSmall
                key={id}
                date={publishedDate}
                image={cardImage}
                slug={slug}
                tags={tags}
                title={title}
              />
            );
          })}
        </div>
      </div>
      <div className="sm:mt-20 mt-14 homepage-grid-desktop-container">
        <div
          className="lg:col-span-7"
          data-component-id="homepage_active_economy_sidebar"
        >
          <HomepageActiveEconomySidebar activeEconomy={activeEconomy} />
        </div>
        <div className="lg:col-span-13">
          <HomepageMosaic mosaic={mosaic} mosaicQuote={mosaicQuote} variant />
        </div>
      </div>
    </div>
  );
};

HomepageActiveEconomy.propTypes = {
  activeEconomy: PropTypes.array,
  header: PropTypes.array,
  mosaic: PropTypes.array,
  mosaicQuote: PropTypes.object,
};

export default HomepageActiveEconomy;
